import { hasPermissionFeature } from '@hooks/hasPermissionFeature';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { RoleEntityInterface } from '@types';
import { FeaturePermission, PagePermission, PermissionActions } from '@enums';
import { PagePermissionItem } from '../PagePermissionItem';
import { RolesPageAccordionControllersMenu } from '../RolesPageAccordionControllersMenu';
import './index.scss';

interface props {
  roles: RoleEntityInterface[];
  canViewRole: boolean;
}

const RolesPageAccordion = ({ roles, canViewRole }: props) => {
  const hasPermissionsForUpdateRole = hasPermissionFeature(
    PagePermission.Roles,
    [FeaturePermission.RoleItem],
    [PermissionActions.Update]
  );

  return (
    <div className="roles-accordion" data-testid="roles-accordion">
      {roles.map(({ id, name, pagePermissions }) => {
        return (
          <Accordion elevation={0} key={id} data-testid={`accordion-container-${id}`}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <AccordionSummary data-testid={`accordion-title-${id}`} expandIcon={<ExpandMore />}>
                <Typography data-testid={`${name}-role`}>{name}</Typography>
              </AccordionSummary>
              {canViewRole && hasPermissionsForUpdateRole && (
                <RolesPageAccordionControllersMenu id={id} />
              )}
            </Box>
            <AccordionDetails className="permission-page__container">
              {pagePermissions.map(
                (page) =>
                  page[PermissionActions.View] && <PagePermissionItem page={page} key={page.name} />
              )}
            </AccordionDetails>
          </Accordion>
        );
      })}
    </div>
  );
};

export { RolesPageAccordion };
